// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CampaignOrdersListTable from "./CampaignOrdersListTable.bs.js";
import * as LoaderComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/loader/LoaderComponent.bs.js";
import * as IncentiveDashboardRepoManager from "../../../../app/incentive/repo/IncentiveDashboardRepoManager.bs.js";

var CampaignOrdersListLoaderConfig = {};

var CampaignOrdersListLoaderComponent = LoaderComponent$Catalyst.LoaderComponentWithoutRefresh(CampaignOrdersListLoaderConfig);

function CampaignOrdersList$CampaignOrdersListLoader(Props) {
  var campaign_id = Props.campaign_id;
  var msisdn = Props.msisdn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var fetchCampaignOrders = function (param) {
    var RepoInstance = IncentiveDashboardRepoManager.getIncentivesRepo(undefined);
    return Curry._3(RepoInstance.fetchCampaignOrders, campaign_id, msisdn, country);
  };
  return React.createElement(CampaignOrdersListLoaderComponent.make, {
              fetchData: fetchCampaignOrders,
              renderView: (function (data) {
                  return React.createElement(CampaignOrdersListTable.make, {
                              tableData: data
                            });
                })
            });
}

var CampaignOrdersListLoader = {
  CampaignOrdersListLoaderConfig: CampaignOrdersListLoaderConfig,
  CampaignOrdersListLoaderComponent: CampaignOrdersListLoaderComponent,
  make: CampaignOrdersList$CampaignOrdersListLoader
};

export {
  CampaignOrdersListLoader ,
  
}
/* CampaignOrdersListLoaderComponent Not a pure module */
